export default "<!-- <app-header></app-header> -->\r\n<router-outlet></router-outlet>\r\n<!-- <app-footer></app-footer> -->"